import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Radio } from 'antd'
import css from '../../common/Form.css'

const PbxForm = ({ onChange, pbxDomain, pbxNumber, pbxServiceType, pbxUsername, pbxVEmail }) => (
  <div className="ant-input-modifier">
    <style>
      {`.ant-input-modifier .ant-row {
          margin-bottom: 9px;
        }`}
    </style>
    <h3>Screen Pop</h3>
    <Form.Item label="Service type" className={css.itemLabel}>
      <Radio.Group
        name="pbxServiceType"
        onChange={onChange}
        value={pbxServiceType}
        className={css.label}
      >
        <Radio.Button value="coredial">Coredial</Radio.Button>
        <Radio.Button value="skyswitch">Skyswitch</Radio.Button>
      </Radio.Group>
    </Form.Item>
    <Form.Item className={css.itemLabel} label="Number (5 digits, required for Coredial):">
      <Input
        onChange={onChange}
        value={pbxNumber}
        name="pbxNumber"
        placeholder="12345"
        maxLength="5"
        className={css.input}
        disabled={pbxServiceType !== 'coredial'}
      />
    </Form.Item>
    <Form.Item className={css.itemLabel} label="Username (required for Coredial):">
      <Input
        onChange={onChange}
        value={pbxUsername}
        name="pbxUsername"
        placeholder="email@example.com"
        className={css.input}
        disabled={pbxServiceType !== 'coredial'}
      />
    </Form.Item>
    <Form.Item label="Domain (required for Skyswitch)" className={css.itemLabel}>
      <Input
        onChange={onChange}
        value={pbxDomain}
        name="pbxDomain"
        placeholder="HappyOrtho.23815.service"
        className={css.input}
        disabled={pbxServiceType !== 'skyswitch'}
      />
    </Form.Item>
    <Form.Item className={css.itemLabel} label="Voicemail email (optional):">
      <Input
        onChange={onChange}
        value={pbxVEmail}
        name="pbxVEmail"
        placeholder="email@example.com"
        className={css.input}
      />
    </Form.Item>
  </div>
)

PbxForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  pbxDomain: PropTypes.string,
  pbxNumber: PropTypes.string,
  pbxServiceType: PropTypes.string,
  pbxUsername: PropTypes.string,
  pbxVEmail: PropTypes.string,
}

PbxForm.defaultProps = {
  pbxDomain: null,
  pbxNumber: null,
  pbxServiceType: null,
  pbxUsername: null,
  pbxVEmail: null,
}

export default PbxForm



// WEBPACK FOOTER //
// ./src/AddPractice/Products/PbxForm.js